export default __webpack_public_path__ + "static/media/bolivia_flag.a48e9163.svg";